import { BifrostBackendNestApi, BifrostBackendApi } from "../gateways/BifrostBackendApi";
import { store } from "../store";

const getApi = () => {
	const useNestOrderPaymentFlow =
		store.getters.featureToggles &&
		store.getters.featureToggles.useNestOrderPaymentFlow;
	return useNestOrderPaymentFlow ? BifrostBackendNestApi : BifrostBackendApi;
};

const OrderCorrespondenceProvider = {
	findAllByOrder(orderId) {
		return getApi().get("/order-correspondence", {
			params: {
				token: orderId
			}
		});
	},

	createNewMessageCustomer({ orderId, message, userConsent }) {
		return getApi().post("/order-correspondence", {
			message,
			sentBy: "customer",
			userConsent
		}, {
			params: {
				token: orderId
			}
		});
	},

	createNewMessageManager({ orderId, message }, jwtToken) {
		return getApi().post("/order-correspondence", {
			message,
			sentBy: "manager"
		}, {
			headers: { Authorization: jwtToken },
			params: {
				token: orderId
			}
		});
	},

	setOrderMessageAsRead({ orderId }, jwtToken) {
		return getApi().patch(`/order-correspondence/${orderId}`, {
			action: "setMessageAsRead"
		}, {
			headers: { Authorization: jwtToken },
			params: {
				token: orderId
			}
		});
	}
};

export default Object.freeze(OrderCorrespondenceProvider);
